import { RadioField } from '@openx/components-core/lib/RadioField/RadioField';
import { DomainTargeting, type DomainTargetingType } from '@openx/types/targeting/domains';
import { useTranslation } from 'react-i18next';

type Props = {
  targetingType: DomainTargetingType | undefined;
  onChange: (newTargetingType: DomainTargetingType) => void;
};

export const RadioTypeSelector = ({ targetingType, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <RadioField
      row
      data-test="domain-targeting-options"
      sx={{ mt: 1 }}
      options={[
        {
          label: t('All subdomains with paths'),
          value: DomainTargeting.ALL_VARIATIONS,
          'data-test': 'domain-targeting-all-variations',
        },
        {
          label: t('Root domains with paths'),
          value: DomainTargeting.NO_SUBDOMAINS,
          'data-test': 'domain-targeting-no-subdomains',
          tooltipPlacement: 'top',
          tooltip: (
            <>
              {t(
                `"All subdomains with paths" (default) targets all standard domain variations (e.g. http, https, www), all paths under the specified domain, plus all subdomains (e.g. shop.domain.com, news.domain.com, ww1.domain.com)`
              )}
              <br />
              {t(
                `"Root domain with paths" targets only the main domain and its standard variations and paths, excluding subdomains`
              )}
            </>
          ),
        },
      ]}
      onChange={(_, field) => {
        switch (field) {
          case DomainTargeting.ALL_VARIATIONS:
            onChange(DomainTargeting.ALL_VARIATIONS);
            break;
          case DomainTargeting.NO_SUBDOMAINS:
            onChange(DomainTargeting.NO_SUBDOMAINS);
            break;
        }
      }}
      value={targetingType || DomainTargeting.ALL_VARIATIONS}
    />
  );
};
